<template>
<div>
  <el-autocomplete

    class="inline-input"
    v-model="self_value"
    :fetch-suggestions="querySearch"
    placeholder="请输入内容"
    @select="handleSelect"
  ></el-autocomplete>
</div>
</template>

<script>
import CommonHelp from "../common/CommonHelp";

export default {
  name: "SearchPartnership",
  props:{
    value:String,
  },
  data(){
    return {
      self_value:"",
      list:[]
    }
  },
  mounted() {
    this.self_value=this.value;
  },
  methods:{
    getData(name,callback){
      var that=this;
      CommonHelp.get("Partnership/getPartnershipList",{name:name},res=>{
        if(res.code) {
          // that.list=res.data
          callback(res.data)
        }
      })
    },
    querySearch(queryString, cb) {
      this.getData(queryString,cb)
    },
    handleSelect(item) {
      this.$emit("onChang",item);
    }
  },
  watch:{
    value(n){
      // console.log(n)
      this.self_value=n;
    },
    self_value(n){
      this.$emit("onValue",n)
    }
  }
}
</script>

<style lang="scss" scoped>
.inline-input{
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/SearchPartnership.vue